export default __webpack_public_path__ + "static/media/plus.9b9daa65.svg";